import clsx from "clsx";
import React from "react";
import classes from "./CustomGridWrapper.module.css";

export default function CustomGridWrapper({
  center = false,
  children,
  animate = false,
}: {
  center?: boolean;
  children: React.ReactNode;
  animate?: boolean;
}) {
  return (
    <div
      className={clsx(classes.gridArea, animate && "progressive-fade-in")}
    >
      {children}
    </div>
  );
}
